export const API_KEY = "8WfMq4ifHv5cf-ywVDCwXiUWCr2Itoa1frGukOnrmV5pAzFuz6mnFQ==";
